import { set as vset } from 'vue'
import { each, keyBy } from 'lodash'

export const update = (state, payload) => {
  each(payload, (value, key) => {
    vset(state, key, value)
  })
}

export const merge = (state, payload) => {
  const cloned = JSON.parse(JSON.stringify(payload))
  vset(state, 'all', {
    ...state.all,
    ...keyBy(cloned, 'id')
  })
}

export const mutationTypes = {
  UPDATE: 'update',
  MERGE: 'merge'
}
